import NextImage from 'next/legacy/image'
import type { FunctionComponent, ReactNode } from 'react'
import { useTranslate } from '../../contexts/TranslationContext'
import SvgCross from '../../svg/icons/Cross'
import { Button } from './Button'
import style from './InfoModal.module.sass'
import { Modal } from './Modal'
import { useScrollLock } from './ScrollLock'

type InfoModalProps = {
	title: string
	lead?: string
	imageAlternativeText?: string
	imageUrl?: string
	content?: ReactNode
	buttonLabel?: string | React.ReactElement
	onClick?: () => void
	closeModal: () => void
	isOpen?: boolean
	url?: string
	disabled?: boolean
	buttonType?: 'button' | 'submit' | undefined
}

export const InfoModal: FunctionComponent<InfoModalProps> = ({
	title,
	lead,
	imageUrl,
	imageAlternativeText,
	onClick,
	content,
	buttonLabel,
	closeModal,
	buttonType,
	isOpen = false,
	disabled = false,
	url,
}) => {
	const translate = useTranslate()

	useScrollLock(isOpen)

	return (
		<Modal close={closeModal} type="info" isOpen={isOpen}>
			<div className={style.closeButton}>
				<Button
					type={{ variant: 'white' }}
					label={<SvgCross />}
					icon={{ aloneStanding: true }}
					onClick={closeModal}
					ariaLabel={translate('modal.close.button')}
				/>
			</div>
			<div className={style.header}>
				<h2 className={style.title}>{title}</h2>
			</div>
			{lead && <p className={style.lead}>{lead}</p>}
			{imageUrl && (
				<div className={style.imageWrapper}>
					<NextImage
						src={imageUrl}
						alt={imageAlternativeText ?? ''}
						title={imageAlternativeText}
						layout="fill"
						objectFit="contain"
					/>
				</div>
			)}
			{content && <div className={style.content}> {content} </div>}
			{buttonLabel && (
				<div className={style.buttonWrapper}>
					{url ? (
						<Button label={buttonLabel} buttonType={buttonType} url={url} disabled={disabled} />
					) : (
						<Button label={buttonLabel} onClick={onClick} buttonType={buttonType} disabled={disabled} />
					)}
				</div>
			)}
		</Modal>
	)
}
